import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import Config from '../../../../Config';
//import noImage from '../images/temp.svg';

export default function UserUpgradeList(props) {
    return (
        <>
            {
                props.serviceList?.length > 0 ? (
                    <div className='addon-list-wrapper'>
                        {
                            props.serviceList.map((item, index) => {
                                if (item.selfCareCmsData?.isRestricted) { return; }

                                let tagStyle = {};

                                if (item.selfCareCmsData?.tagColor) {
                                    tagStyle.backgroundColor = item.selfCareCmsData?.tagColor;
                                }

                                if (item.selfCareCmsData?.tagTextColor) {
                                    tagStyle.color = item.selfCareCmsData?.tagTextColor;
                                }

                                return (
                                    <div className='addon-item' key={index}>
                                        {item.selfCareCmsData?.icon && <div className='image-wrapper'> <Image src={Config.epiBaseUrl + item.selfCareCmsData?.icon} /> </div>}
                                        <div className='details-wrapper'>
                                            <div className='addon-title'>
                                                <span> {item.selfCareCmsData?.title ? item.selfCareCmsData?.title : item.description} </span>
                                                {
                                                    item.selfCareCmsData?.tagText &&
                                                    <span className='addon-tag' style={tagStyle}>{item.selfCareCmsData?.tagText}</span>
                                                }
                                            </div>
                                            <div className='addon-sub-title'> {item.selfCareCmsData?.subTitle} </div>
                                        </div>
                                        <div className='button-wrapper'> <a href='#' onClick={(e) => {e.preventDefault(); props.onServiceClick(e, item);}}>מעניין אותי {'>>'}</a> </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                ) : (
                    <div className='no-results-wrapper'>
                        <div className='icon-wrapper'></div>
                        <div className='no-results'>
                            <div className='no-results-title'> הישארו מעודכנים </div>
                            <div className='no-results-sub-title'> לא מצאנו שדרוגים חדשים לחשבון שלך </div>
                        </div>
                    </div>
                )

            }
        </>
    );
};
